<template>
  <v-container fluid>
    <h2 class="page-title mb-1">New MRR</h2>
    <p class="page-desc mb-4">
      Cuánto MRR nuevo entra cada mes y de dónde viene: altas, reactivaciones,
      expansión de contratos existentes y churn.
    </p>

    <NewMrrReportTable />
  </v-container>
</template>

<script>
import NewMrrReportTable from '@/components/NewMrrReportTable.vue';

export default {
  name: 'NewMrrReport',
  components: { NewMrrReportTable },
};
</script>

<style scoped>
.page-title {
  color: #104b94;
  font-weight: 700;
}
.page-desc {
  font-size: 13px;
  color: #555;
  max-width: 760px;
}
</style>
